import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { DateUtil, _, UrlUtil } from '@hugendubel/utils';
import { Persistore, CookieUtil } from 'persistore';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var TokenType;
(function (TokenType) {
    TokenType["ANONYMOUS"] = "ANONYMOUS";
    TokenType["BONUS_SHOP"] = "BONUS_SHOP";
    TokenType["CUSTOMER"] = "CUSTOMER";
    TokenType["LIMITED_CUSTOMER_ACCESS"] = "LIMITED_CUSTOMER_ACCESS";
})(TokenType || (TokenType = {}));
var _JWT = {
    tryParseTokenType: function (type) {
        // flow can not determine the type correctly after usage of Object.values
        var result = Object.values(TokenType).find(function (v) { return v === type; });
        if (!result) {
            Track.error(TRACK_ID('2018-07-24 01:47:57'), 'Unknown JWT token type: ' + type);
            return undefined;
        }
        return result;
    },
};
var tryParse = function (token) {
    try {
        var parts = token.split('.');
        if (parts.length !== 3) {
            Track.error(TRACK_ID('2018-07-24 01:49:48'), "The JWT string has ".concat(parts.length, " parts instead of 3."));
            return;
        }
        var decodedClaims = atob(parts[1]);
        var json = JSON.parse(decodedClaims);
        var isGuest = !!json.g;
        var tokenType = _JWT.tryParseTokenType(json.t);
        var customerId = json.cust && String(json.cust);
        if (tokenType)
            return { tokenType: tokenType, customerId: customerId, isGuest: isGuest };
    }
    catch (e) {
        Track.error(TRACK_ID('2019-04-09 08:58:05'), 'Could not parse JWT because: ' + e.message);
    }
};
var JWT = { tryParse: tryParse };

var Method;
(function (Method) {
    Method["GET"] = "get";
    Method["POST"] = "post";
})(Method || (Method = {}));
// default token checks to be used most often in the application which use the WsClient
// later on there might be coming more, like LIMITED_CUSTOMER_ACCESS or BONUS_CUSTOMER etc.
var TokenChecks = {
    isCustomer: function (token) { return !!token && token.tokenType === TokenType.CUSTOMER; },
    isLimitedCustomerAccess: function (token) {
        return !!token && token.tokenType === TokenType.LIMITED_CUSTOMER_ACCESS;
    },
    isGuest: function (token) { return !!token && token.isGuest; },
    isBonusShopCustomer: function (token) { return !!token && token.tokenType === TokenType.BONUS_SHOP; },
};
var VoidParser = function () { };
var WsErrorCode = {
    NO_VALID_TOKEN: 2,
    EXPIRED_TOKEN: 3,
    AUTHENTICATION_FAILED: 4,
    INVALID_ARGUMENTS: 5,
    DATA_AUTHORIZATION_FAILED: 6,
    DOWNLOAD_NOT_YET_AVAILABLE: 7,
    DOWNLOAD_NOT_YET_ALLOWED: 8,
    NO_SUCH_ARTICLE: 10,
    SUBSCRIPTIONS_ASSOCIATED_WITH_PAYMENT_DATA: 1006,
    CREDIT_CARD_EXPIRED: 1008,
    CREDIT_CARD_REJECTED: 1009,
    COMPUTOP_PAYMENT_REJECTED: 12712,
    INVALID_PAYMENT_TYPE: 1010,
    INVALID_IBAN: 1011,
    NO_SUCH_PAYMENT_DATA: 1016,
    CUSTOMER_INVALID_PASSWORD: 2001,
    CUSTOMER_USERNAME_NOT_UNIQUE: 2003,
    SOLVENCY_CHECK_FAILED: 2010,
    PASSWORD_TOO_SIMPLE_DIGITS_AND_LETTERS: 2014,
    PASSWORD_TOO_SIMPLE_USERNAME: 2015,
    PASSWORD_TOO_SIMPLE_MIN_LENGTH: 2016,
    CUSTOMER_CANCELLED_PAYPAL: 2021,
    ADDRESS_NOT_FOUND: 2102,
    INVALID_EMAIL_ADDRESS: 9101,
    COUPON_INVALID: 10000,
    NO_SUCH_FREIGHTZONE: 11500,
    ILLEGAL_ARTICLE: 12900,
    INVALID_BASKET_ITEM_GIFT_INFO: 12901,
    DOWNLOAD_NOT_BUYABLE: 12902,
    GIFT_DELIVERY_DATE_TOO_LITTLE_TIME: 12903,
    GIFT_DELIVERY_DATE_TOO_MUCH_TIME: 12904,
    EXTERNAL_ARTICLE_NOT_BUYABLE: 13100,
    NO_ITEMS_FOUND_FOR_ORDER: 13202,
    NO_SUCH_ORDER: 13301,
    DELIVERY_TYPE_NOT_ALLOWED: 13400,
    DELIVERY_ADDRESS_REQUIRED: 13410,
    INVOICE_ADDRESS_REQUIRED: 13411,
    NO_SUCH_FORM: 14000,
    BUNDLE_BASKET_ITEM_INVALID: 15002,
    BASKET_ITEM_INVALID_FOR_TYPE: 15003,
    INVALID_ONE_TIME_TOKEN: 17013,
    ALREADY_SUBSCRIBED: 21102,
    LOYALTY_ALREADY_CONNECTED: 22000,
    LOYALTY_BACKEND_EXCEPTION: 22001,
    LOYALTY_CUSTOMER_UNCONNECTED: 22005,
    LOYALTY_CUSTOMER_UNKNOWN: 22006,
    NO_CONTEXT_HELP: 27000,
};
var ClientErrorCode = {
    GENERAL: -1,
    UNEXPECTED_TYPE: -2,
    TOKEN_CHECK_FAILED: -3,
    // customer
    NO_CUSTOMER: -10,
    // common
    STORAGE_WRITE_ERROR: -11,
    // cart
    ARTICLE_ID_MISMATCHING: -32,
    // checkout
    INVALID_GOOGLE_MAPS_INIT: -40,
    GOOGLE_MAPS_INIT_TIMEOUT: -41,
    GOOGLE_MAPS_INIT_FAILED: -42,
    GEOCODER_ERROR: -43,
    ORDER_NOT_ALLOWED: -51,
    ORDER_TOKEN_MISSING: -52,
    SHOPPING_CART_CHANGED_SERVER_SIDE: -53,
    ORDER_CALCULATION_FAILED: -54,
    NO_COUPON_CODE: -60,
    COUPON_AND_GIFT_CARD_SIMULTANEOUSLY: -61,
};
var WsError = /** @class */ (function (_super) {
    __extends(WsError, _super);
    function WsError(errorCode, info, statusDetails, type) {
        if (statusDetails === void 0) { statusDetails = []; }
        if (type === void 0) { type = 'API'; }
        var params = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            params[_i - 4] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray(["WsError (".concat(type, ": ").concat(errorCode, ")")], params, false)) || this;
        Error.captureStackTrace && Error.captureStackTrace(_this, WsError);
        _this.errorCode = errorCode;
        _this.info = info;
        _this.statusDetails = statusDetails;
        _this.type = type;
        _this.name = 'WsError';
        return _this;
    }
    WsError.isInstance = function (err) {
        return err instanceof Error && err.name === 'WsError';
    };
    return WsError;
}(Error));
var ClientError = /** @class */ (function (_super) {
    __extends(ClientError, _super);
    function ClientError(trackId, errorCode, comment) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray(["ClientError (".concat(errorCode, "): ").concat(comment)], params, false)) || this;
        Error.captureStackTrace && Error.captureStackTrace(_this, ClientError);
        _this.errorCode = errorCode;
        _this.comment = comment;
        _this.name = 'ClientError';
        Track.error(trackId, _this.message);
        return _this;
    }
    ClientError.isInstance = function (err) {
        return err instanceof Error && err.name === 'ClientError';
    };
    return ClientError;
}(Error));
/**
 * Our WsClientError has the intend to stop certain requests but avoid error tracking,
 * because the encountered errors are actually valid cases and were already tracked if necessary.
 */
var WsClientError = /** @class */ (function (_super) {
    __extends(WsClientError, _super);
    function WsClientError(m) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArray(['WsClientError: ' + m], params, false)) || this;
        Error.captureStackTrace && Error.captureStackTrace(_this, WsClientError);
        _this.name = 'WsClientError';
        return _this;
    }
    WsClientError.isInstance = function (err) {
        return err instanceof Error && err.name === 'WsClientError';
    };
    return WsClientError;
}(Error));
var toApiJson = function (o) {
    return ('json:' + JSON.stringify(o));
};
var toApiList = function (o) { return o.join(','); };
var WsParser = { toApiJson: toApiJson, toApiList: toApiList };

var handleError = function (name, was, shouldBe, displayValue) {
    var received = displayValue || "of type ".concat(Object.prototype.toString.call(was));
    throw new ClientError(TRACK_ID('2018-05-22 03:59:36'), ClientErrorCode.UNEXPECTED_TYPE, "Expected ".concat(name, " to be a ").concat(shouldBe, ". But was ").concat(received, "."));
};
var optionalOf = function (fn) {
    return function (arg, name) {
        return arg === null || arg === undefined ? undefined : fn(arg, name);
    };
};
var falsyToUndefined = function (fn) {
    return function (arg, name) {
        return !arg ? undefined : fn(arg, name);
    };
};
var numberCheck = function (arg, name) {
    return typeof arg === 'number' && !isNaN(arg) ? arg : handleError(name, arg, 'number');
};
var idCheck = function (arg, name) {
    var num = numberCheck(arg, name);
    return num % 1 === 0 && num > 0 ? num : handleError(name, arg, 'id', String(num));
};
var stringCheck = function (arg, name) {
    return typeof arg === 'string' ? arg : handleError(name, arg, 'string');
};
var notEmptyStringCheck = function (arg, name) {
    return stringCheck(arg, name) || handleError(name, arg, 'not empty string', 'empty');
};
var booleanCheck = function (arg, name) {
    return typeof arg === 'boolean' ? arg : handleError(name, arg, 'boolean');
};
var arrayCheck = function (arg, name) { return (Array.isArray(arg) ? arg : handleError(name, arg, 'array')); };
var notEmptyArrayCheck = function (arg, name) {
    var array = arrayCheck(arg, name).filter(function (arg) { return arg !== null && arg !== undefined; });
    return array.length ? array : handleError(name, arg, 'not empty array', 'empty');
};
var objectCheck = function (arg, name) {
    return Object.prototype.toString.call(arg) === '[object Object]' ? arg : handleError(name, arg, 'object');
};
var dateStringCheck = function (arg, name) {
    var date = DateUtil.parse(stringCheck(arg, name));
    return date || handleError(name, arg, 'date', "'".concat(arg, "'"));
};
var Type = {
    array: arrayCheck,
    notEmptyArray: notEmptyArrayCheck,
    number: numberCheck,
    id: idCheck,
    string: stringCheck,
    notEmptyString: notEmptyStringCheck,
    boolean: booleanCheck,
    object: objectCheck,
    dateString: dateStringCheck,
    optional: {
        array: optionalOf(arrayCheck),
        number: optionalOf(numberCheck),
        string: optionalOf(stringCheck),
        boolean: optionalOf(booleanCheck),
        dateString: optionalOf(dateStringCheck),
    },
    falsyToUndefined: {
        number: falsyToUndefined(numberCheck),
        string: falsyToUndefined(stringCheck),
    },
};

var parse$4 = function (json) { return ({
    accessToken: Type.string(json.accessToken, 'accessToken'),
    refreshToken: Type.string(json.refreshToken, 'refreshToken'),
}); };
var WsTokenPair = { parse: parse$4 };

var _TokenStore = {};
_TokenStore.useSession = false;
var accessTokenName = 'accessToken';
var refreshTokenName = 'refreshToken';
var accessTokenNameTemp = 'tempAccessToken';
var tempSessionName = 'tempSession';
/**
 * Favor the session storage token over the local storage token.
 */
var _get = function (name) { return (_TokenStore.useSession ? Persistore.session : Persistore).get(name); };
var _set = function (name, value) {
    return (_TokenStore.useSession ? Persistore.session : Persistore).set(name, value);
};
var isTemporarySession = function () { return Persistore.get(tempSessionName) === 'true'; };
var getRefresh = function () {
    var useTemporarySession = isTemporarySession();
    if (useTemporarySession) {
        return undefined;
    }
    else {
        return _get(refreshTokenName);
    }
};
var getAccess = function () {
    var useTemporarySession = isTemporarySession();
    if (useTemporarySession) {
        var usedSessionBefore = _TokenStore.useSession;
        _TokenStore.useSession = false;
        var token = _get(accessTokenNameTemp);
        _TokenStore.useSession = usedSessionBefore;
        return token;
    }
    else {
        return _get(accessTokenName);
    }
};
// enable a temporary login session, without saving token to localstorage e.g. for oauth purposes
var startTemporarySession = function () {
    var usedSessionBefore = _TokenStore.useSession;
    _TokenStore.useSession = false;
    _set(tempSessionName, 'true');
    _TokenStore.useSession = usedSessionBefore;
};
// clear temporary access token and flag
var clearTemporarySession = function () {
    Persistore.remove(accessTokenNameTemp);
    Persistore.remove(tempSessionName);
};
// set access and refresh token in local storage or temporary access token in session storage
var set$1 = function (_a) {
    var accessToken = _a.accessToken, refreshToken = _a.refreshToken;
    var useTemporarySession = isTemporarySession();
    if (useTemporarySession) {
        var usedSessionBefore = _TokenStore.useSession;
        _TokenStore.useSession = false;
        _set(accessTokenNameTemp, accessToken);
        _TokenStore.useSession = usedSessionBefore;
    }
    else {
        _set(accessTokenName, accessToken);
        _set(refreshTokenName, refreshToken);
    }
};
var setSession = function (tokenPair) {
    _TokenStore.useSession = true;
    TokenStore.set(tokenPair);
};
var _removeSession = function () {
    Persistore.session.remove(accessTokenName);
    Persistore.session.remove(refreshTokenName);
};
var init$2 = function (allowSession) {
    if (allowSession) {
        _TokenStore.useSession = !!Persistore.session.get(accessTokenName);
    }
    else {
        _TokenStore.useSession = false;
        // this behaviour will later on make other applications
        // drop the session tokens if present, when visiting
        // e.g. the bookshop will drop those tokens and the customer
        //      would need to login as guest again
        _removeSession();
    }
};
/**
 * Removes all tokens - from session AND local storage
 */
var remove$1 = function () {
    _removeSession();
    Persistore.remove(accessTokenName);
    Persistore.remove(refreshTokenName);
    _TokenStore.useSession = false;
};
var TokenStore = {
    getAccess: getAccess,
    getRefresh: getRefresh,
    startTemporarySession: startTemporarySession,
    isTemporarySession: isTemporarySession,
    clearTemporarySession: clearTemporarySession,
    set: set$1,
    remove: remove$1,
    setSession: setSession,
    init: init$2,
};

var CONFIG = {}; // will be filled on initialization
var configure = function (_a) {
    var _b = _a.onLogout, onLogout = _b === void 0 ? function () { } : _b, _c = _a.onUpdate, onUpdate = _c === void 0 ? function () { return Promise.resolve(); } : _c, defaultLoginEndpoint = _a.defaultLoginEndpoint, // we can not assign here the default value which is 'anonymousloginjwt' since flow dislikes it
    _d = _a.cred, // we can not assign here the default value which is 'anonymousloginjwt' since flow dislikes it
    cred = _d === void 0 ? {} : _d, tokenProvider = _a.tokenProvider, _e = _a.allowSessionToken, allowSessionToken = _e === void 0 ? false : _e;
    CONFIG.onLogout = onLogout;
    CONFIG.onUpdate = onUpdate;
    CONFIG.defaultLogin =
        defaultLoginEndpoint === null
            ? null // this disables the default login
            : {
                name: 'authentication/' + (defaultLoginEndpoint || 'anonymousloginjwt'),
                parser: WsTokenPair.parse,
                method: Method.POST,
                omitToken: true,
            };
    CONFIG.cred = cred;
    CONFIG.tokenProvider = tokenProvider;
    CONFIG.allowSessionToken = allowSessionToken;
    TokenStore.init(allowSessionToken);
};
var BaseConfig = { configure: configure };

var Globals = {
    window: function () { return window; },
    timestamp: function () { return Date.now(); },
};

var _Controller = {};
_Controller.lastTokenString = undefined;
_Controller.lastToken = undefined;
_Controller.update = function (accessToken) {
    var tokenChanged = _Controller.lastTokenString !== accessToken;
    if (tokenChanged) {
        // parse next token
        var token = accessToken ? JWT.tryParse(accessToken) : undefined;
        var prevToken = _Controller.lastToken;
        // assign updates
        _Controller.lastTokenString = accessToken;
        _Controller.lastToken = token;
        // inform the application about the updated token, if callback has been set already
        return CONFIG.onUpdate && CONFIG.onUpdate(prevToken, token);
    }
    return Promise.resolve();
};
var synchronize = function () {
    _Controller.update(TokenStore.getAccess());
};
var update$1 = function (tokenPair) {
    TokenStore.set(tokenPair);
    return _Controller.update(tokenPair.accessToken);
};
var updateSession = function (tokenPair) {
    if (CONFIG.allowSessionToken) {
        // by setting directly to session, the token store will favor
        // the session over the local storage from now on (until logged out)
        TokenStore.setSession(tokenPair);
        _Controller.update(tokenPair.accessToken);
    }
};
var LOCAL_STORAGE_WHITELIST = ['uc_settings', 'uc_user_interaction', 'removeItem']; //I don't want to remove "removeItem". Probably just a test artifact
_Controller.clearStorage = function () {
    var _a = Globals.window(), localStorage = _a.localStorage, sessionStorage = _a.sessionStorage;
    if (localStorage && 'removeItem' in localStorage) {
        Object.keys(localStorage).forEach(function (value) {
            !LOCAL_STORAGE_WHITELIST.includes(value) && localStorage.removeItem(value);
        });
    }
    if (sessionStorage && 'clear' in sessionStorage) {
        sessionStorage.clear();
    }
};
var COOKIE_WHITELIST = [
    'lastBranchId',
    'MYSHOP_ID',
    'sessioncode',
    'sessioncodeExtra',
    'cookiefirst-consent',
    'cookiefirst-id',
];
_Controller.clearCookies = function () {
    CookieUtil.getAll().forEach(function (_a) {
        var name = _a[0];
        !COOKIE_WHITELIST.includes(name) && CookieUtil.remove(name);
    });
};
var logout = function () {
    _Controller.clearStorage();
    _Controller.clearCookies();
    Controller.synchronize();
};
var getToken = function () { return _Controller.lastToken; };
var Controller = {
    update: update$1,
    updateSession: updateSession,
    logout: logout,
    synchronize: synchronize,
    getToken: getToken,
};

var _Fetcher = {};
_Fetcher.logout = function () {
    // get the current token before removing it
    var currentToken = Controller.getToken();
    // remove the tokens in any case
    TokenStore.remove();
    // finally inform the application about the deleted token
    CONFIG.onLogout(currentToken);
};
/**
 * Method to prepare the headers.
 */
var headers = function (_a) {
    var auth = _a.auth, encoding = _a.encoding;
    var result = {};
    if (auth)
        result.Authorization = 'Bearer ' + auth;
    if (encoding)
        result['Content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    return result;
};
/**
 * Does an default login if no token was present at all.
 */
_Fetcher.getOrAcquireAccessToken = function (omitToken) { return __awaiter(void 0, void 0, void 0, function () {
    var current, tokens;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (omitToken)
                    return [2 /*return*/, undefined];
                current = TokenStore.getAccess();
                if (!CONFIG.defaultLogin || current)
                    return [2 /*return*/, current];
                return [4 /*yield*/, _Fetcher.defaultLogin(CONFIG.defaultLogin)];
            case 1:
                tokens = _a.sent();
                return [2 /*return*/, tokens.accessToken];
        }
    });
}); };
var getOrAcquireAccessToken = _Fetcher.getOrAcquireAccessToken;
/**
 * Executes the call by applying the call name, params and method correctly.
 */
_Fetcher.basicFetch = function (callName, method, params, omitToken, sameSiteCookies) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, baseUrl, endpoint, paramsInSearch, paramsInBody;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, _Fetcher.getOrAcquireAccessToken(omitToken)];
            case 1:
                accessToken = _a.sent();
                baseUrl = '/rest/v1/';
                endpoint = baseUrl + callName;
                paramsInSearch = method === Method.GET ? UrlUtil.queryToSearch(params) : '';
                paramsInBody = method === Method.GET ? undefined : UrlUtil.queryToString(params);
                return [2 /*return*/, Globals.window().fetch(endpoint + paramsInSearch, {
                        method: method,
                        headers: Fetcher.headers({ auth: accessToken, encoding: true }),
                        body: paramsInBody,
                        credentials: sameSiteCookies ? 'same-origin' : 'omit',
                    })];
        }
    });
}); };
/**
 * Wraps all the logic of performing a call.
 * The following logically steps will be performed in the following order:
 *
 * 1) Call needs a login and the user is not logged in -> Propagates a ClientError to the caller.
 * 2) Anonymous login for the first call without access token.
 * 3) Performing the call.
 *  3.1) Call was successful -> Parsing the result and return it to the caller.
 *  3.2) Call fails due to expired token -> Tries to refresh tokens with refresh token and perform the call once again.
 *  3.3) Call fails due to invalid token or refresh fails -> Calls "tokenChange".
 *  3.4) Call fails due to any other api exception -> Propagates fetch error to the caller.
 *  3.5) Call fails due to any other issue -> Propagates general fetch error to the caller.
 *
 */
var execute = function (call, params) {
    if (params === void 0) { params = {}; }
    return _Fetcher.fetchInternal(call, params, true);
};
_Fetcher.fetchInternal = function (call, params, retry) {
    var tokenCheck = call.tokenCheck;
    if (tokenCheck && !tokenCheck(Controller.getToken())) {
        var errorMsg = "Could not perform call '".concat(call.name, "' due to failing token check.");
        if (retry) {
            return Promise.reject(new ClientError(TRACK_ID('2018-08-28 02:23:55'), ClientErrorCode.TOKEN_CHECK_FAILED, errorMsg));
        }
        else {
            // since this might be a regular case (after the necessary token might have been cleared
            // when it was invalid and therefore the token check does not apply anymore), we don't want to
            // track an error for this special case
            return Promise.reject(new WsClientError(errorMsg));
        }
    }
    return _Fetcher
        .basicFetch(call.name, call.method || Method.GET, params, !!call.omitToken, !!call.withCookies)
        .then(_Fetcher.wsApiResultFromResponse)
        .then(call.parser)
        .catch(function (err) {
        if (WsError.isInstance(err) || ClientError.isInstance(err)) {
            if (err.errorCode === WsErrorCode.EXPIRED_TOKEN && retry) {
                return Fetcher.refreshOrLogout().then(function () { return _Fetcher.fetchInternal(call, params, false); });
            }
            if (err.errorCode === WsErrorCode.NO_VALID_TOKEN && retry) {
                Track.error(TRACK_ID('2018-05-22 03:47:03'), 'Found invalid token: ' + err.message);
                _Fetcher.logout();
                return _Fetcher.fetchInternal(call, params, false); // no retry since we get a new token
            }
            throw err;
        }
        throw new ClientError(TRACK_ID('2018-07-24 01:46:37'), ClientErrorCode.GENERAL, 'Unable to parse the WSAPI response. ' + err.message);
    });
};
/**
 * Parse the status details of an error.
 */
var parseStatusDetail = function (json) {
    var o = Type.object(json, 'StatusDetail');
    var code = Type.number(o.code, 'StatusDetail.code');
    return { code: code };
};
/**
 * Herein we perform the basic validations and parsing which apply to all of our api calls.
 */
_Fetcher.wsApiResultFromResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var apiJson, resultCode, result, statusDetailsJson;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (response.status !== 200) {
                    throw new WsError(response.status, undefined, [], 'HTTP');
                }
                return [4 /*yield*/, response.json()];
            case 1:
                apiJson = _a.sent();
                resultCode = apiJson.resultCode;
                result = apiJson.result;
                if (resultCode === 0) {
                    // the api also might return null.
                    // Since we perform a parsing step later on, we cast null to an empty object
                    return [2 /*return*/, result || {}];
                }
                statusDetailsJson = Type.optional.array(apiJson.statusDetails, 'ApiJson.statusDetails');
                throw new WsError(resultCode, result, statusDetailsJson ? statusDetailsJson.map(parseStatusDetail) : []);
        }
    });
}); };
// *************************
// Refresh Token Start
// *************************
/**
 * Make the refresh token call if a refresh token was provided.
 */
var refreshTokensInternal = function () { return __awaiter(void 0, void 0, void 0, function () {
    var refreshToken, tokenPair;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                refreshToken = TokenStore.getRefresh();
                if (!refreshToken)
                    return [2 /*return*/, Promise.reject(new WsError(WsErrorCode.NO_VALID_TOKEN))];
                return [4 /*yield*/, Globals.window()
                        .fetch('/rest/v1/authentication/refresh', {
                        headers: Fetcher.headers({ auth: refreshToken }),
                        credentials: 'omit',
                    })
                        .then(_Fetcher.wsApiResultFromResponse)
                        .then(WsTokenPair.parse)];
            case 1:
                tokenPair = _a.sent();
                Controller.update(tokenPair);
                return [2 /*return*/, tokenPair];
        }
    });
}); };
/**
 * Wrapper for the refresh token to avoid parallel calls, while performing another token refresh.
 */
_Fetcher.refreshTokens = _.onlyOneInParallel(refreshTokensInternal);
var refreshOrLogout = function () { return _Fetcher.refreshTokens().catch(_Fetcher.logout); };
// *************************
// Refresh Token End
// *************************
// *************************
// Default Login Start
// *************************
/**
 * Steps which are performed while making the default login
 * ATTENTION: In most cases the default login is nothing different from the anonymous login.
 * BUT:
 *  --> E.g. within the POS-App the default login is a login as affiliate.
 *  --> E.g. within the Bonus-Shop or Account-App this one will/should not even be used.
 */
var defaultLoginInternal = function (call) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenProvider, tokenPair;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tokenProvider = CONFIG.tokenProvider || (function () { return _Fetcher.fetchInternal(call, CONFIG.cred, false); });
                return [4 /*yield*/, tokenProvider()];
            case 1:
                tokenPair = _a.sent();
                Controller.update(tokenPair);
                return [2 /*return*/, tokenPair];
        }
    });
}); };
/**
 * Wrapper for the default login to avoid parallel calls, while performing the default login.
 */
_Fetcher.defaultLogin = _.onlyOneInParallel(defaultLoginInternal);
// *************************
// Anonymous Login End
// *************************
var Fetcher = { execute: execute, Method: Method, refreshOrLogout: refreshOrLogout, headers: headers, getOrAcquireAccessToken: getOrAcquireAccessToken };

var _FocusListener = {};
var FIVE_MIN = 300000;
_FocusListener.lastAutoRefresh = Globals.timestamp();
_FocusListener.refreshOrLogout = function () {
    var now = Globals.timestamp();
    if (now - _FocusListener.lastAutoRefresh > FIVE_MIN) {
        _FocusListener.lastAutoRefresh = now;
        Fetcher.refreshOrLogout();
    }
};
var init$1 = function () {
    Globals.window().onfocus = _FocusListener.refreshOrLogout;
};
var FocusListener = { init: init$1 };

var init = function (config) {
    BaseConfig.configure(config);
    // initial synchronization on startup
    Controller.synchronize();
    // add focus listener to refresh the token
    FocusListener.init();
};

var _limitedCustomerCheck = function (token) {
    return TokenChecks.isCustomer(token) || TokenChecks.isLimitedCustomerAccess(token);
};
var createCall = function (call) {
    return function (params) {
        return Fetcher.execute(call, params);
    };
};
var createCustomerCall = function (call) { return createCall(__assign(__assign({}, call), { tokenCheck: TokenChecks.isCustomer })); };
var createLimitedCustomerCall = function (call) { return createCall(__assign(__assign({}, call), { tokenCheck: _limitedCustomerCheck })); };

var parser = function (_a) {
    var enumValues = _a.enumValues, defaultValue = _a.defaultValue, enumTypeName = _a.enumTypeName;
    return function (value) {
        var result = Object.values(enumValues).find(function (v) { return v === value; });
        if (result === undefined) {
            var errorMessage = "".concat(enumTypeName, " '").concat(value, "' unknown.");
            if (defaultValue !== undefined) {
                Track.error(TRACK_ID('2019-08-29 09:14:17'), errorMessage);
                return defaultValue;
            }
            else {
                throw new ClientError(TRACK_ID('2019-08-29 09:14:24'), ClientErrorCode.UNEXPECTED_TYPE, errorMessage);
            }
        }
        else {
            return result;
        }
    };
};
var EnumUtil = { parser: parser };

var Salutation;
(function (Salutation) {
    Salutation["MR"] = "HERR";
    Salutation["MRS"] = "FRAU";
    Salutation["COMPANY"] = "FIRMA";
    Salutation["PACKSTATION"] = "PACKSTAT";
    Salutation["UNDEFINED"] = "UNDEFINED";
    Salutation["PERSON"] = "DIVERS";
})(Salutation || (Salutation = {}));
var parse$3 = EnumUtil.parser({
    enumValues: Salutation,
    enumTypeName: 'Salutation',
});
var WsSalutation = { parse: parse$3 };

var parse$2 = function (json) { return ({
    bonusPoints: Type.number(json.bonusPoints, 'Customer.bonusPoints'),
    email: Type.string(json.email, 'Customer.email'),
    firstName: Type.string(json.firstName, 'Customer.firstName'),
    loyaltyActive: Type.boolean(json.loyaltyActive, 'Customer.loyaltyActive'),
    lastName: Type.string(json.lastName, 'Customer.lastName'),
    myshopFlag: Type.boolean(json.myshopFlag, 'Customer.myshopFlag'),
    privacyFlag: Type.boolean(json.privacyFlag, 'Customer.privacyFlag'),
    salutationCode: WsSalutation.parse(Type.string(json.salutationCode, 'Customer.salutationCode')),
    hashId: Type.string(json.hashId, 'Customer.hashId'),
    newCustomer: Type.boolean(json.newCustomer, 'Customer.newCustomer'),
    serviceLoginAllowed: Type.boolean(json.serviceLoginAllowed, 'Customer.serviceLoginAllowed'),
    amountWishlistItems: Type.number(json.amountWishlistItems, 'Customer.amountWishlistItems'),
    phone: Type.optional.string(json.phone, 'Customer.phone'),
    mobilePhone: Type.optional.string(json.mobilePhone, 'Customer.mobilePhone'),
    birthDate: json.birthDate ? DateUtil.parse(json.birthDate) : undefined,
}); };
var toTrackingCustomer = function (_a) {
    var birthDate = _a.birthDate, email = _a.email, firstName = _a.firstName, loyaltyActive = _a.loyaltyActive, lastName = _a.lastName, mobilePhone = _a.mobilePhone, myshopFlag = _a.myshopFlag, newCustomer = _a.newCustomer, hashId = _a.hashId, phone = _a.phone;
    return ({
        email: email,
        firstName: firstName,
        lastName: lastName,
        loyaltyActive: loyaltyActive,
        myshopFlag: myshopFlag,
        newCustomer: newCustomer,
        hashId: hashId,
        phone: phone,
        mobilePhone: mobilePhone,
        birthDate: birthDate,
    });
};
var WsCustomer = { parse: parse$2, toTrackingCustomer: toTrackingCustomer };

var fetchCustomerBaseData = createLimitedCustomerCall({
    name: 'customer/basedata',
    parser: WsCustomer.parse,
    method: Method.POST,
});
var KEY = 'customer';
var get$1 = function () {
    try {
        var customerJsonString = Persistore.session.get(KEY);
        if (!customerJsonString)
            return undefined;
        var customerJson = JSON.parse(customerJsonString);
        if (Object.prototype.toString.call(customerJson) !== '[object Object]') {
            Track.error(TRACK_ID('2018-11-23 12:04:17'), 'Found customer data with invalid format in local storage: ' + customerJsonString);
            return undefined;
        }
        return WsCustomer.parse(customerJson);
    }
    catch (e) {
        Track.error(TRACK_ID('2018-11-23 11:18:37'), 'Error while parsing customer data from local storage: ' + e.message);
        return undefined;
    }
};
var set = function (customer) { return Persistore.session.set(KEY, JSON.stringify(customer)); };
var remove = function () { return Persistore.session.remove(KEY); };
var loadCustomer = function () {
    return _CustomerStore
        .fetchCustomerBaseData()
        .then(function (customer) {
        CustomerStore.set(customer);
        return customer;
    })
        .catch(function (error) {
        Track.error(TRACK_ID('2018-11-23 11:25:33'), "Could not load customer data, because: ".concat(error.message));
        return undefined;
    });
};
var update = function (authenticated) {
    var current = _CustomerStore.get();
    if (current) {
        if (!authenticated) {
            CustomerStore.remove();
            return Promise.resolve(undefined);
        }
        else {
            return Promise.resolve(current);
        }
    }
    else if (authenticated) {
        return _CustomerStore.loadCustomer();
    }
    else {
        return Promise.resolve(undefined);
    }
};
var updateAfterOrder = function () {
    // after an order the customer is no longer a new customer and we need to update the newCustomer flag
    var current = _CustomerStore.get();
    if (current) {
        var customerAfterOrder = __assign(__assign({}, current), { newCustomer: false });
        CustomerStore.set(customerAfterOrder);
        return customerAfterOrder;
    }
    else {
        Track.error(TRACK_ID('2019-04-12 09:30:09'), 'Unable to update newCustomer after order because there was no customer in storage.');
    }
};
var _CustomerStore = { loadCustomer: loadCustomer, get: get$1, fetchCustomerBaseData: fetchCustomerBaseData };
var CustomerStore = { update: update, remove: remove, updateAfterOrder: updateAfterOrder, set: set, get: get$1 };

var AD_CODE_COOKIE = 'sessioncode';
var AD_CODE_EXTRA_PARAM_COOKIE = 'sessioncodeExtra';
var get = function () { return CookieUtil.get(AD_CODE_COOKIE); };
var getExtraParam = function () {
    var cookie = CookieUtil.get(AD_CODE_EXTRA_PARAM_COOKIE);
    if (!cookie) {
        return undefined;
    }
    var cookiePair = cookie.split('=', 2);
    if (cookiePair.length === 2 && cookiePair[0] && cookiePair[1]) {
        return { name: cookiePair[0], value: cookiePair[1] };
    }
    return undefined;
};
var AdCodeStore = { get: get, getExtraParam: getExtraParam };

var parserFor = function (itemParser) {
    return function (json) { return ({
        items: Type.array(json.items, 'PageableList.items').map(itemParser),
        limit: Type.number(json.limit, 'PageableList.limit'),
        offset: Type.number(json.offset, 'PageableList.offset'),
        results: Type.number(json.results, 'PageableList.results'),
    }); };
};
var WsPageableList = { parserFor: parserFor };

var parse$1 = function (value) {
    if (value % 1 !== 0) {
        throw new ClientError(TRACK_ID('2018-11-08 08:42:46'), ClientErrorCode.UNEXPECTED_TYPE, "Euro cents have to be of type integer. Value was ".concat(value, "."));
    }
    return value;
};
/**
 * @returns a human-readable string in Euro with german decimal separator (e.g. 42,67 €)
 */
var getFormatted = function (euroCents) { return (euroCents / 100).toFixed(2).replace('.', ',') + ' €'; };
var negate = function (euroCents) { return -euroCents; };
var zero = 0;
var Money = { parse: parse$1, getFormatted: getFormatted, zero: zero, negate: negate };

var parse = function (json) { return ({
    number: Type.number(json.number, 'AvailabilityData.number'),
    text: Type.string(json.text, 'AvailabilityData.text'),
    currentlyAvailable: Type.boolean(json.currentlyAvailable, 'AvailabilityData.currentlyAvailable'),
    preorder: Type.boolean(json.preorder, 'AvailabilityData.preorder'),
}); };
var WsAvailabilityData = { parse: parse };

var WsClient = { init: init, Controller: Controller };

export { AdCodeStore, ClientError, ClientErrorCode, CustomerStore, EnumUtil, Fetcher, JWT, Method, Money, Salutation, TokenChecks, TokenStore, TokenType, Type, VoidParser, WsAvailabilityData, WsClient, WsClientError, WsCustomer, WsError, WsErrorCode, WsPageableList, WsParser, WsSalutation, WsTokenPair, createCall, createCustomerCall, createLimitedCustomerCall };
